import "../i18nFallback";
import { Sentry } from "../sentryInstrumentReact";
import React, { useState } from 'react';
import Cookies from 'js-cookie';

import { useCart } from './CartContext';

function CheckoutDiscount() {
  const { 
    discountCode, 
    discountAmount,
    setDiscountCode, 
    discountLocked, 
    setDiscountLocked, 
    setDiscountAmount,
    cartSubtotalWithDiscount,
    setCartSubtotalWithDiscount,
    setCartSubtotal,
  } = useCart();
  const [isFocused, setIsFocused] = useState(false);
  const [discountError, setDiscountError] = useState('');
  const isActive = isFocused || discountCode !== '';
  const csrftoken = Cookies.get('csrftoken');
  const formattedCartSubtotalWithDiscount = parseFloat(cartSubtotalWithDiscount).toLocaleString('en-US', {
    style: 'currency', currency: 'USD'
  });


  function handleDiscountChange(event) {
    setDiscountCode(event.target.value);
  };
  

  async function applyDiscount() {
    setDiscountError('');
    try {
      const response = await fetch("/store/_api/cart/discount/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken
        },
        body: JSON.stringify({discount_code: discountCode}),
      });
      
      if (!response.ok) {
        const data = await response.json();
        setDiscountError(data.discount_code[0]);
        setDiscountCode("");
        throw new Error(data.cart[0] || 'An discount code error occurred');
      } else {
        const data = await response.json();
        setDiscountAmount(parseFloat(data.discount_amount).toFixed(2));
        setCartSubtotalWithDiscount(parseFloat(data.discounted_subtotal).toFixed(2));
        setDiscountLocked(true);
      }
      
    } catch (error) {
	  if (Sentry && Sentry.getClient()) {
		Sentry.captureException(error, {stage: "applyDiscount"});
	  }
    } 
  };


  // cancels discount
  async function handleDiscountClick() {
    try {
      const response = await fetch("/store/_api/cart/discount/", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken
        },
      });
      const data = await response.json();
      setDiscountAmount(0);
      setDiscountLocked(false);
      setDiscountCode('');
      setCartSubtotal(parseFloat(data.subtotal).toFixed(2));

    } catch (error) {
      Sentry.captureException(error, {stage: "handleDiscountClick"});
    }
  }


  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  }


  if (discountLocked) {
    return (
      <>
        <div className="discount-applied">
          <div className="discount-header">
            <label>{window.gettext("Discount Applied")}</label>
            <button onClick={handleDiscountClick} className="remove btn-tiny">{window.gettext("remove")}</button>
          </div>
          <div className="discount-details">
            <span className='code'>
              {discountCode}
            </span>
            <span className='amount'>
              -${discountAmount}
            </span>
          </div>
        </div>

        <div className="cart-discounted-total">
        {window.gettext("Total with Discount")}: <strong>{formattedCartSubtotalWithDiscount}</strong>
        </div>
      </>
    );
  }


  return (
    <div className="form-row discount-form-row form-group-row">
      <div className="form-group">
        {discountError != '' && 
          <p className='error' style={{color: 'red', paddingBlock: '.1rem'}}>{discountError}</p>
        }
        <label className={`text-label ${isActive ? 'active' : ''}`.trim()} htmlFor="discount_code">{window.gettext("Discount Code")}</label>
        <input 
          type="text" 
          className="form-control" 
          value={discountCode} 
          name="discount_code" 
          id="discount_code" 
          onChange={handleDiscountChange} 
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
        />
      </div>
      <button className="btn btn-sm btn-primary-light" onClick={applyDiscount}>{window.gettext("Apply")}</button>
    </div>

  );
}


export default CheckoutDiscount;
